import { Timestamp } from 'firebase/firestore';

export type CreatorDmControl = 'agent' | 'human' | string;
export type CreatorDmStatus = 'ongoing' | 'complete' | 'closed' | string;
export type CreatorDmMessageRole = 'model' | 'user' | string;
export type CreatorDmYesNoFilter = '' | 'y' | 'n' | 'all';

export interface CreatorDmSessionFilters {
    status?: CreatorDmStatus | '' | 'all';
    creator_responded?: CreatorDmYesNoFilter;
    control?: CreatorDmControl | '' | 'all';
}

export const defaultCreatorDmSessionFilters: CreatorDmSessionFilters = {
    status: '',
    creator_responded: '',
    control: '',
};

export interface CreatorDmSocialAccount {
    uuid: string;
    handle: string;
    name: string;
    platform: string;
    profile_picture_url?: string;
}

export interface CreatorDmSession {
    id: string;
    recipient?: string;
    control?: CreatorDmControl;
    agent?: string;
    state?: string;
    status?: CreatorDmStatus;
    social_account: CreatorDmSocialAccount;
    last_message_at?: Timestamp | { seconds: number; nanoseconds: number };
    expires_at?: Timestamp | { seconds: number; nanoseconds: number };
    last_message_id?: string;
    sender_id?: string;
    phone_number?: string;
    is_read?: boolean;
}

export interface CreatorDmMessage {
    id: string;
    text: string;
    role: CreatorDmMessageRole;
    created_at?: Timestamp | { seconds: number; nanoseconds: number };
    state?: string;
    intent?: string;
}
